import { render, staticRenderFns } from "./confirmFormFromEmail.vue?vue&type=template&id=8cb22846&scoped=true&"
import script from "./confirmFormFromEmail.vue?vue&type=script&lang=js&"
export * from "./confirmFormFromEmail.vue?vue&type=script&lang=js&"
import style0 from "./confirmFormFromEmail.vue?vue&type=style&index=0&id=8cb22846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb22846",
  null
  
)

export default component.exports